import { createContext, useContext, type ReactNode } from 'react'
import type { ModuleAccess } from '@syscolect/domain'

export interface ModuleAccessValue {
  isResolving: boolean
  /** Modules the organization contracted. */
  orgSlugs: ReadonlySet<string>
  /** Best access of the active profile per slug: any full instance wins. */
  grantedSlugs: ReadonlyMap<string, ModuleAccess>
}

const ModuleAccessContext = createContext<ModuleAccessValue | null>(null)

export function ModuleAccessProvider({
  value,
  children,
}: {
  value: ModuleAccessValue
  children: ReactNode
}) {
  return <ModuleAccessContext.Provider value={value}>{children}</ModuleAccessContext.Provider>
}

/** Null outside the provider (e.g. login). */
export function useModuleAccessContext(): ModuleAccessValue | null {
  return useContext(ModuleAccessContext)
}
